import { SPI, FormFieldWidget, ViewType, ModelFieldType, FormM2OSelectFieldWidget, Widget } from '@kunlun/dependencies';
@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Form,
    model: [
      'deli.aries.seller.SellerDistributionCreateOrderParam'
    ],
    ttype: ModelFieldType.ManyToOne,
    multi: false,
    name: 'deliveryAddressCopy'
  })
)
@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Form,
    model: [
      'deli.aries.platform.major.DeliAriesPlatformRelationApply',
      'deli.aries.platform.DeliAriesPlatformCustomerDistributor',
      'deli.aries.seller.DeliAriesSellerInvitationQRCode',
      'deli.aries.seller.DeliAriesSellerDistributor'
    ],
    ttype: ModelFieldType.ManyToOne,
    multi: false,
    name: 'collaborationBank'
  })
)
// @ts-ignore
export class distributionDefaultSelectCheckFirstWidget extends FormM2OSelectFieldWidget {
  initialize(props: any): this {
    super.initialize(props);
    return this;
  }
  @Widget.Reactive()
  private get needInitOptions() {
    return true;
  }
  protected async initLoadOptions() {
    await super.initLoadOptions();
    if (this.options?.length == 1) {
      this.change(this.options?.[0]);
    }
  }
  @Widget.Watch('value')
  protected watchOrderType(value: string) {
    if (!value && this.options?.length == 1) {
      this.initLoadOptions()
    }
  }
}
